// test1990
(1990 && 0);
